import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { Button } from '@/components/ui/Button/Button';
import { professionalRfpOfferPath, professionalRfpOfferedPath, } from '@/utils/router/links';
/**
 * コンサルタント：「提案内容を入力する」の編集画面への表示を制御するコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalOneOfferBalloonLinkButton = (props) => {
    const { hasOffer, id, isLinkDisabled } = props;
    return (_jsx(DynamicLink, Object.assign({ className: 'w-[200px] md:w-full xl:w-[200px]', noLinkElement: isLinkDisabled ? 'span' : undefined, to: hasOffer ? professionalRfpOfferedPath(id) : professionalRfpOfferPath(id) }, { children: _jsx(Button, Object.assign({ color: 'orange', disabled: isLinkDisabled, isFull: true, size: 'md' }, { children: _jsx("span", { children: hasOffer ? '提案内容を確認する' : '提案内容を入力する' }) })) })));
};
